import { Phone, Mail, MessageCircle, Sparkles } from 'lucide-react';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

export const CTASection = () => {
  const WHATSAPP_LINK = `https://wa.me/5511999999999?text=${encodeURIComponent(
    'Olá! Quero uma avaliação gratuita do meu caso trabalhista com um advogado especialista.'
  )}`;

  return (
    <section
      id="contato"
      data-testid="cta-section"
      className="py-14 sm:py-20 bg-slate-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal delay={0.1} className="relative overflow-hidden bg-blue-600 rounded-2xl sm:rounded-3xl">
          {/* Background Circles */}
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute top-0 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-48 sm:w-64 h-48 sm:h-64 bg-white rounded-full translate-y-1/2 -translate-x-1/2" />
          </div>

          <div className="relative p-6 sm:p-12 lg:p-16">
            <Reveal delay={0.2} className="text-center max-w-2xl mx-auto mb-8 sm:mb-10">
              <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-white/20 text-white text-xs sm:text-sm font-semibold px-3.5 py-1.5 rounded-full mb-4 sm:mb-6">
                <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                <span>Vamos resolver isso juntos</span>
              </div>
              <h2
                data-testid="cta-title"
                className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3 sm:mb-4"
              >
                Pronto pra buscar o que é seu por direito?
              </h2>
              <p className="text-blue-100 text-sm sm:text-lg leading-relaxed">
                Fale com a gente agora! Nossa análise é 100% gratuita e sem compromisso.
                Você só paga se ganhar.
              </p>
            </Reveal>

            {/* Contact Options — cards com toque amigável no mobile */}
            <StaggerGroup staggerDelay={0.1} startDelay={0.3} className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 max-w-3xl mx-auto">
              <StaggerItem
                as="a"
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-link"
                whileTap={{ scale: 0.98 }}
                className="flex items-center gap-3.5 sm:gap-4 bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 shadow-sm hover:shadow-md transition-all group cursor-pointer"
              >
                <div className="w-11 h-11 sm:w-12 sm:h-12 bg-green-500 rounded-xl flex items-center justify-center shrink-0">
                  <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-slate-900 text-sm sm:text-base">WhatsApp</p>
                  <p className="text-slate-500 text-xs sm:text-sm">Resposta rápida no Zap</p>
                </div>
              </StaggerItem>

              <StaggerItem
                as="a"
                href="tel:+5511999999999"
                data-testid="phone-link"
                whileTap={{ scale: 0.98 }}
                className="flex items-center gap-3.5 sm:gap-4 bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 shadow-sm hover:shadow-md transition-all group cursor-pointer"
              >
                <div className="w-11 h-11 sm:w-12 sm:h-12 bg-blue-500 rounded-xl flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-slate-900 text-sm sm:text-base">Telefone</p>
                  <p className="text-slate-500 text-xs sm:text-sm">(11) 99999-9999</p>
                </div>
              </StaggerItem>

              <StaggerItem
                as="a"
                href="mailto:contato@meusdireitostrabalhistas.com"
                data-testid="email-link"
                whileTap={{ scale: 0.98 }}
                className="flex items-center gap-3.5 sm:gap-4 bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 shadow-sm hover:shadow-md transition-all group cursor-pointer"
              >
                <div className="w-11 h-11 sm:w-12 sm:h-12 bg-slate-700 rounded-xl flex items-center justify-center shrink-0">
                  <Mail className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-slate-900 text-sm sm:text-base">E-mail</p>
                  <p className="text-slate-500 text-xs sm:text-sm">Envie sua dúvida</p>
                </div>
              </StaggerItem>
            </StaggerGroup>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
